import { render, staticRenderFns } from "./RaceVideoPage.vue?vue&type=template&id=3ef6bd96&scoped=true"
import script from "./RaceVideoPage.vue?vue&type=script&lang=ts"
export * from "./RaceVideoPage.vue?vue&type=script&lang=ts"
import style0 from "./RaceVideoPage.vue?vue&type=style&index=0&id=3ef6bd96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef6bd96",
  null
  
)

export default component.exports